import React, { Component, lazy, Suspense } from 'react';
import routes from 'config/config/routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import jwt from 'jsonwebtoken';
// eslint-disable-next-line no-unused-vars
import whatInput from 'what-input';
import { LoginAgent } from 'views/00_Login/LoginAgent';
import { LoginClient } from 'views/00_Login/LoginClient';
import { Dashboard } from 'views/01_AccessPoint/Dashboard';
import { UpsertProduct } from 'views/02_UpsertProduct/UpsertProduct';
import { SimulationData } from 'views/03_SimulationData/SimulationData';
import { Simulation } from 'views/04_Simulation/Simulation';
import { ClientData } from 'views/05_ClientData/ClientData';
import { Health } from 'views/07_Questionnaires/Health';
import { Pbc } from 'views/07_Questionnaires/Pbc';
import { BankAccount } from 'views/08_BankAccount/BankAccount';
import { IdentityBiometricSteps } from 'views/09_IdentityBiometricSteps/IdentityBiometricSteps';
import { IdentityBiometricSelect } from 'views/10_IdentityBiometricSelect/IdentityBiometricSelect';
import { IdentityBiometricUpsert } from 'views/11_IdentityBiometricUpsert/IdentityBiometricUpsert';
import { IdentityBiometric } from 'views/12_IdentityBiometric/IdentityBiometric';
import { ActivateProduct } from 'views/14_ActivateProduct/ActivateProduct';
import { SignatureSteps } from 'views/15_SignatureSteps/SignatureSteps';
import { SignatureRead } from 'views/16_SignatureRead/SignatureRead';
import { SignatureContract } from 'views/17_SignatureContract/SignatureContract';
import { ProductCreationFinished } from 'views/18_ProductCreationFinished/ProductCreationFinished';
import { Continue } from 'views/_Handlers/00_AccessPoint/Continue';
import { LoadTarget } from 'views/_Handlers/01_LoadTarget/LoadTarget';
import {
	ApplicationWrapper,
	EnvelopesWrapper,
	Module,
	Page,
	WithSession,
} from '@coinscrap/webapp-core';
import WrappersComponent from 'wrappers/WrappersComponent';
import Animations from 'layout/Animations/Animations';
import { MainLayout } from 'layout/MainLayout';
import { startUpController } from 'helpers/startUpController';
import { AutoLanding } from './views/01_AccessPoint/AutoLanding';
import DashboardProvider from './views/01_AccessPoint/contexts/Dashboard';
import { Bmw } from './views/01_AccessPoint/personalized/Bmw';
import { Rastreator } from './views/01_AccessPoint/personalized/Rastreator';
import { CannotConfirm } from './views/_Common/CannotConfirm/CannotConfirm';

require('intersection-observer');

//APP INIT
ApplicationWrapper.init({
	projectName: 'alz-vr',
	contextTheme: 'light',
	disableNative: true,
	onStartupParams: () => (startUpController.params = {}),
});

const queryClient = new QueryClient();

export const DebugContext = React.createContext();
export default class App extends Component {
	render() {
		return (
			<>
				<DebugContext.Provider
					value={
						window?.__CLIENT_ENV?.CLIENT_ENV_DEBUG_MESSAGES_ENABLED === 'true' || false
					}
				>
					<WrappersComponent>
						<MainLayout>
							{/*B2B AGENTE*/}
							<Module path={'/agent'} defaultRoute={routes.loginAgent}>
								<Page
									name={routes.loginAgent}
									component={LoginAgent}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Module path={'/internal'} defaultRoute={routes.dashboard}>
									<WithSession
										pageNoSession={routes.loginAgent}
										//availableRoles={['AGENT', 'GLOBAL_AGENT']}
										sessionValidator={(sessionData) => {
											if (sessionData) {
												//console.log(sessionData);
												let decodedToken = jwt.decode(sessionData.token);
												//console.log(decodedToken);
												if (
													decodedToken?.roles?.length &&
													decodedToken.roles.find(
														(role) =>
															role.identifier === 'AGENT' ||
															role.identifier === 'GLOBAL_AGENT',
													)
												) {
													return sessionData.token;
												}
												return false;
											}
											return false;
										}}
									>
										<DashboardProvider>
											<QueryClientProvider client={queryClient}>
												<Page
													path={'/Dashboard'}
													name={routes.dashboard}
													component={Dashboard}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
											</QueryClientProvider>
										</DashboardProvider>
									</WithSession>
								</Module>
							</Module>

							{/*
							<FLUJOS CLIENTE>
								B2B:
									→ /continue → /loadTarget → /simulation → ...
								B2C:
									→ /client → /loginClient → /upsertProduct → /simulationData → /simulation → ...
						*/}

							{/*B2B CONTINUE LINK*/}
							<Page
								name={routes.continue}
								pushAnimation={Animations.push}
								backAnimation={Animations.back}
								component={Continue}
							/>

							{/*B2B y B2C CLIENTE*/}
							<Module path="/client" defaultRoute={routes.loginClient}>
								<Page
									name={routes.bmw}
									component={Bmw}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Page
									name={routes.rastreator}
									component={Rastreator}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Page
									name={routes.loginClient}
									component={LoginClient}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Page
									path={'/access'}
									name={routes.autolanding}
									component={AutoLanding}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Page
									path={'/loadTarget'}
									name={routes.loadTarget}
									component={LoadTarget}
									pushAnimation={Animations.push}
									backAnimation={Animations.back}
								/>
								<Module path="/internal" defaultRoute={routes.upsertProduct}>
									<WithSession pageNoSession={routes.loginClient}>
										<Page
											name={routes.upsertProduct}
											component={UpsertProduct}
											pushAnimation={Animations.push}
											backAnimation={Animations.back}
										/>
										<Module path="/target/:targetId">
											<Page
												path={'/simulationData'}
												name={routes.simulationData}
												component={SimulationData}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
											<Page
												path={'/simulation'}
												name={routes.simulation}
												component={Simulation}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
											<Page
												path={'/clientData'}
												name={routes.clientData}
												component={ClientData}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
											<Module
												path={'/questionnaires'}
												defaultRoute={routes.pbc}
											>
												<Page
													path={'/pbc'}
													name={routes.pbc}
													component={Pbc}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
												<Page
													path={'/health'}
													name={routes.health}
													component={Health}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
											</Module>
											<Module
												path={'/identityDocuments'}
												defaultRoute={routes.identityBiometricSteps}
											>
												<Page
													path={'/identityBiometricSteps'}
													name={routes.identityBiometricSteps}
													component={IdentityBiometricSteps}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
												<Module path="/select/:selectType">
													<Page
														path={'/identityBiometricSelect'}
														name={routes.identityBiometricSelect}
														component={IdentityBiometricSelect}
														pushAnimation={Animations.push}
														backAnimation={Animations.back}
													/>
												</Module>
												<Page
													path={'/identityBiometricUpsert'}
													name={routes.identityBiometricUpsert}
													component={IdentityBiometricUpsert}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
												<Page
													path={'/identityBiometric'}
													name={routes.identityBiometric}
													component={IdentityBiometric}
													pushAnimation={Animations.push}
													backAnimation={Animations.back}
												/>
											</Module>
											<Page
												path={'/bankAccount'}
												name={routes.bankAccount}
												component={BankAccount}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
											<Page
												path={'/activateProduct'}
												name={routes.activateProduct}
												component={ActivateProduct}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
											<Module
												path={'/sign/:envelopeId'}
												defaultRoute={routes.signatureSteps}
											>
												<EnvelopesWrapper>
													<Page
														path={'/signatureSteps'}
														name={routes.signatureSteps}
														component={SignatureSteps}
														pushAnimation={Animations.push}
														backAnimation={Animations.back}
													/>
													<Page
														path={'/signatureRead'}
														name={routes.signatureRead}
														component={SignatureRead}
														pushAnimation={Animations.push}
														backAnimation={Animations.back}
													/>
													<Page
														path={'/signatureContract'}
														name={routes.signatureContract}
														component={SignatureContract}
														pushAnimation={Animations.push}
														backAnimation={Animations.back}
													/>
													<Page
														path={'/productCreationFinished'}
														name={routes.productCreationFinished}
														component={ProductCreationFinished}
														pushAnimation={Animations.push}
														backAnimation={Animations.back}
													/>
												</EnvelopesWrapper>
											</Module>
										</Module>
										<Suspense fallback={<div>Loading...</div>}>
											<Page
												path={'/cannotConfirm'}
												name={routes.cannotConfirm}
												component={CannotConfirm}
												pushAnimation={Animations.push}
												backAnimation={Animations.back}
											/>
										</Suspense>
									</WithSession>
								</Module>
							</Module>
						</MainLayout>
					</WrappersComponent>
				</DebugContext.Provider>
			</>
		);
	}
}
